<template>
  <v-row>
    <v-card class="elevation-12" width='100%'>
      <v-toolbar color="primary" dark>
        <v-card-title><v-icon color='white'>mdi-database-export</v-icon>&nbsp; Uploader</v-card-title>
      </v-toolbar>
      <v-card-text>
        <v-row align="center" justify="center">
          <v-file-input 
            @change="concatAfter();validate()"
            @click ="rearmar"
            @click:clear ="clean"
            v-model="files"
            color='primary'
            counter
            accept=".xlsx,.xls"
            label="File input"
            multiple
            chips
            placeholder="Select your files"
            prepend-icon="mdi-paperclip"
            outlined>
            
            <template v-slot:selection="{ index, text }">
              <v-chip
                :color ="files[index].color ?  files[index].color : null"
                dark
                label
                close
                small
                @click:close="cerrar(index)">
                {{ text }}
              </v-chip>
            </template>
          </v-file-input>
        </v-row>

        <v-row>
          <v-btn
            width='100%'
            color='primary'
            :disabled = "bload"
            @click="showForm=true">
            load
          </v-btn>
        </v-row> 

      </v-card-text>
    </v-card>

    <loaderform 
      :Showdialog="showForm"  
      :files="files"
      :files2="files2"
      @Showdialog="showForm = $event"
      @validate="validate"/>
    <Alert :show="alert"/>   

  </v-row>
</template>

<script lang="ts">
  import Vue from 'vue'
  import Loaderform from './Loaderform.vue'
  import Alert from '../utilitys/Alert.vue'
  export default Vue.extend({
    name: 'Loader',
    components:{
      Loaderform,
      Alert
    },
    data: () => ({

      alert:{
        show: false,
        icon: null,
        text: null,
        color: null,
        time: 2000
      },


      bload: true,
      showForm:false,

      AfterFile:[],
      files: [],
      files2: [],
    }),
    
    methods:{
        validate: function(){
        this.files2 = [];
        this.alert.show=false;
        this.bload=false;

        if (this.files.length <= 0) {

          this.alert.show=true;
          this.alert.icon='mdi-alert'
          this.alert.text = "no hay ningun elemento seleccionado";
          this.alert.color = 'error';

          this.bload= true;

          return
        }
        for (const ite of this.files) {
          let col = "success"
          if(!/.xlsx$/.exec(ite.name)){
            col='error'
            this.alert.show=true;
            this.alert.icon='mdi-alert';
            this.alert.text = 'hay al menos un archivo no valido';
            this.alert.color = 'error';

            this.bload = true;
          }

          const item = {
            rotate: false,
            check: false,
            noCheck: false,
            file: ite,
            horario: false
          };

          ite.color = col
          
          this.files2.push(item)
        }
      },
      cerrar: function(index){
        this.files2.splice(index,1);
        this.files.splice(index,1);
        this.validate()
      },
      rearmar: function(){
        this.AfterFile = [];
        if(this.files.length > 0){
          this.AfterFile = this.files;
        }
      },
      concatAfter: function(){
        for(let item of this.AfterFile){
          this.files.push(item);
        }
      },
      clean: function(){
        this.files = [];
        this.files2 = [];
        this.AfterFile = [];
      }
    }
  })
</script>
